const initialState = {
    list: [],
};

export default function recipes(state = initialState, action) {
  switch(action.type) {
    case 'ADD_RECEIPE': {
          return {
              ...state,
              list: [...state.list, action.item]
          };
    }
    case 'SET_RECEIPES': {
        return {
            ...state,
            list: action.list
        };
  }
    default: return state;
    }
}